import { RootState } from '../../store';

export const getInitialTelegramChatListSelector = (state: RootState) =>
  state.telegramChatSliceReducer.initialTelegramChatList;

export const getInitialTelegramChatPageSelector = (state: RootState) =>
  state.telegramChatSliceReducer.initialTelegramChatPage;

export const getInitialTelegramChatTotalCountSelector = (state: RootState) =>
  state.telegramChatSliceReducer.initialTelegramChatTotalCount;

export const getAssignedTelegramChatListSelector = (state: RootState) =>
  state.telegramChatSliceReducer.assignedTelegramChatList;

export const getAssignedTelegramChatPageSelector = (state: RootState) =>
  state.telegramChatSliceReducer.assignedTelegramChatPage;

export const getAssignedTelegramChatTotalCountSelector = (state: RootState) =>
  state.telegramChatSliceReducer.assignedTelegramChatTotalCount;

export const getProcessingTelegramChatSelector = (state: RootState) =>
  state.telegramChatSliceReducer.processingTelegramChat;
